import { ErrorMessage } from "formik";
import { Form, InputGroup } from "react-bootstrap";
import { BsEye, BsEyeSlash } from "react-icons/bs";

const InputField = ({
  className,
  type,
  name,
  placeholder,
  value,
  onChange,
  onBlur,
  showPasswordToggle,
  showPassword,
  setShowPassword,
  asterick,
  errorMessage,
  label,
  as,
  disabled = false,
  max = null,
  step,
  pattern,
  min,
  onInput,
  onWheel,
  autoComplete,
}) => {
  return (
    <Form.Group className={className}>
      <Form.Label htmlFor={name}>
        {label}
        {asterick && <span className="text-danger">*</span>}
      </Form.Label>
      <InputGroup>
        <Form.Control
          id={name}
          type={showPassword ? "text" : type}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          as={as}
          disabled={disabled}
          max={max}
          maxLength={max}
          step={step}
          onInput={onInput}
          pattern={pattern}
          autoComplete={autoComplete}
          min={min}
          onWheel={onWheel}
          style={{
            ...(as === "textarea" ? { resize: "none", height: "150px" } : {}),
            ...(disabled ? { backgroundColor: "#f0f0f0", color: "#8A92A6" } : {}),
          }}
        />
        {showPasswordToggle && (
          <InputGroup.Text
            onClick={() => setShowPassword((prev) => !prev)}
            style={{ cursor: "pointer" }}
          >
            {showPassword ? <BsEye /> : <BsEyeSlash />}
          </InputGroup.Text>
        )}
      </InputGroup>
      <ErrorMessage name={name} component="div" className="text-danger" />
      {Array.isArray(errorMessage) ? (
        errorMessage.map((error, index) => (
          <span key={index} className="w-100 mt-1 small text-danger">
            {error}
            <br />
          </span>
        ))
      ) : (
        errorMessage && (
          <span className="w-100 mt-1 small text-danger">
            {errorMessage}
            <br />
          </span>
        )
      )}
    </Form.Group>
  );
};

export default InputField;
